export default [
    
    
      //  statistics  router
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "/statistics",
        name: "statistics",
        component: () => import("@/layouts/index/StatisticIndex.vue"),
        children: [
          {
            meta: {
              is_auth: true,
              is_admin: true,
              title: "Statistiques",
              layout: "dashboard",
            },
            path: "index",
            name: "statistics-index",
            component: () => import("@/views/statistics/Listing.vue"),
          },
          {
            meta: {
              is_auth: true,
              is_admin: true,
              title: "Fiche journalière",
              layout: "dashboard",
            },
            path: "daily/sheet",
            name: "statistics-daily-sheet",
            component: () => import("@/views/statistics/DailySheet.vue"),
          },
        ],
      },
    
]